import { getShoppingAssistantForwardedHeaders } from './getShoppingAssistantForwardedHeaders'

export function onShoppingAssistantForwardedHeadersRequest({
  options: { headers },
}: {
  options: { headers: Headers }
}) {
  const forwardedHeaders = getShoppingAssistantForwardedHeaders()
  Object.entries(forwardedHeaders).forEach(([key, value]) => {
    headers.set(key, value)
  })
}
